import Card from "Components/Common/Card/Card";
import CardImage from "Components/Common/Card/CardImage/CardImage";
import TaskTemplateListDetailsBlock from "Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListCard/TaskTemplateListDetailsBlock/TaskTemplateListDetailsBlock";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import styles from "./TaskTemplateListCard.scss";

interface IProps {
    className?: string;
    taskTemplate: TaskTemplate;
    style?: React.CSSProperties;
    onMouseDown?: React.MouseEventHandler<HTMLElement>;
    onTouchStart?: React.TouchEventHandler<HTMLElement>;
}

const TaskTemplateListCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <Card className={`${styles.card} ${props.className}`} style={props.style} onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
        <div className={styles.titleWrapper}>
            <CardImage src={props.taskTemplate.videoThumbnailUrl || props.taskTemplate.pictureUrl} className={styles.cardImage} />
            <h2 className={styles.title}>{props.taskTemplate.name}</h2>
        </div>
        <TaskTemplateListDetailsBlock taskTemplate={props.taskTemplate} />
    </Card>
);

export default TaskTemplateListCard;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListCard/TaskTemplateListCard.tsx